import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Button, Icon } from 'semantic-ui-react';
import Modal from '../../../../../../common/components/CustomModal/CustomModal';
import * as activityActions from '../../../../activity.actions';
import * as activitySelectors from '../../../../activity.selectors';
import PromoCodesImported from './PromoCodesImported';

const AUTOMATION_NAME = 'promoCodesImported';

class PromoCodeImportedWrapper extends React.PureComponent {

  static propTypes = {
    actions: PropTypes.func,
    isModalOpen: PropTypes.bool,
    modalValidationErrors: PropTypes.object,
    selectedPromoCodesImportedMode: PropTypes.string,
    isPromoCodeImportedInProgress: PropTypes.bool,
    tempBulk: PropTypes.object,
    index: PropTypes.number,
  };

  onCloseModal = () => {
    this.props.actions.resetPromoCodesImportModal();
  }

  onSaveModal = () => {
    this.props.actions.onSavePromoCodesImportModal(this.props.index, this.props.selectedPromoCodesImportedMode, this.props.tempBulk);
  }

  onCancelChanges = () => {
    this.props.actions.resetPromoCodesImportModal();
  }


  render() {
    // eslint-disable-next-line react/prop-types
    const { formatMessage } = this.props.intl;
    const modalClassNames = 'membership-global-modal membership-filters-modal';
    return (
      <Modal
        className={modalClassNames}
        automationIdPrefix={AUTOMATION_NAME}
        header={
          formatMessage({ id: 'promoCode.imported.upload-dialog.title' })
        }
        actions={[
          <Button
            key="promoCodesImportCancelBtn"
            onClick={this.onCloseModal}
            basic
            className="link modal-button"
            disabled={this.props.isPromoCodeImportedInProgress}
            data-automation-id="promoCodes.import.btnCancel"
          >
            {formatMessage({ id: 'general.button.cancel' })}
          </Button>,
          <Button
            key="promoCodesImportImportBtn"
            onClick={this.onSaveModal}
            className="modal-button"
            data-automation-id="promoCodes.import.btnImport"
            disabled={this.props.isPromoCodeImportedInProgress}
            loading={this.props.isPromoCodeImportedInProgress}
          >
            {formatMessage({ id: 'general.button.save' })}
          </Button>
        ]}
        trigger={this.trigger}
        content={
          <PromoCodesImported
            tempBulk={this.props.tempBulk}
            validationErrors={this.props.modalValidationErrors}
            selectedPromoCodesImportedMode={this.props.selectedPromoCodesImportedMode}
            index={this.props.index}
            isModalInProgress={this.props.isPromoCodeImportedInProgress}
          >
          </PromoCodesImported>
        }
        size={960}
        closeIcon={<Icon className="como-ic-close" name="close" onClick={this.onCancelChanges} />}
        open={this.props.isModalOpen}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isModalOpen: activitySelectors.getIsPromoCodeImportedModalOpen(state),
  modalValidationErrors: activitySelectors.getPromoCodesImportedValidationErrors(state),
  selectedPromoCodesImportedMode: activitySelectors.getPromoCodesImportedMode(state),
  isPromoCodeImportedInProgress: activitySelectors.getPromoCodesImportedInProgress(state),
  tempBulk: activitySelectors.getPromoCodesImportedTempBulk(state),
  index: activitySelectors.getPromoCodesImportedActiveIndex(state)
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(activityActions, dispatch)
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  injectIntl,
  withConnect
)(PromoCodeImportedWrapper);
